import { conns } from '@cfg/axiosConfig.tsx';

import type {
  ManualDiscountRequestPayload,
  SaleOrderCreatePayload,
  SaleOrderOut,
  SalePaymentConfirmationOut,
  SalePaymentCreatePayload,
  SalePaymentOut,
  SalePaymentConfirmPayload,
} from '../types';

const SALE_ORDERS_KEY = 'erp:orders:create' as const;
const ORDER_DISCOUNT_KEY = 'erp:orders:discounts:order' as const;
const LINE_DISCOUNT_KEY = 'erp:orders:discounts:line' as const;
const ORDER_PAYMENTS_KEY = 'erp:orders:payments:add' as const;
const ORDER_CONFIRM_KEY = 'erp:orders:payments:confirm' as const;

export const createSaleOrder = async (payload: SaleOrderCreatePayload): Promise<SaleOrderOut> => {
  const { data } = await conns<SaleOrderOut>(SALE_ORDERS_KEY).post(payload);
  return data;
};

export const applyOrderManualDiscount = async (
  orderId: number,
  payload: ManualDiscountRequestPayload,
): Promise<SaleOrderOut> => {
  const { data } = await conns<SaleOrderOut>(ORDER_DISCOUNT_KEY, [orderId, 'discounts', 'order']).post(
    payload,
  );
  return data;
};

export const applyLineManualDiscount = async (
  orderId: number,
  saleItemId: number,
  payload: ManualDiscountRequestPayload,
): Promise<SaleOrderOut> => {
  const { data } = await conns<SaleOrderOut>(LINE_DISCOUNT_KEY, [
    orderId,
    'items',
    saleItemId,
    'discount',
  ]).post(payload);
  return data;
};

export const addSalePayment = async (
  orderId: number,
  payload: SalePaymentCreatePayload,
): Promise<SalePaymentOut> => {
  const { data } = await conns<SalePaymentOut>(ORDER_PAYMENTS_KEY, [orderId, 'payments']).post(payload);
  return data;
};

export const confirmSalePayments = async (
  orderId: number,
  payload: SalePaymentConfirmPayload,
): Promise<SalePaymentConfirmationOut> => {
  const { data } = await conns<SalePaymentConfirmationOut>(ORDER_CONFIRM_KEY, [
    orderId,
    'payments',
    'confirm',
  ]).post(payload);
  return data;
};

export { createSaleOrder as createPosSaleOrder };
